import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Link from 'valuelink';
import { Button, Checkbox, Col, Row, Select, Spin, Modal, message } from 'antd';
import { Input, NumberInput } from 'valuelink/lib/tags';
import Tappable from 'react-tappable/lib/Tappable';
import { SemiboldText, ButtonText } from '../../components/common/Text';
import UploadingComponent from '../../components/common/UploadingComponent';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchBasicProfile,
  uploadProfilePicture,
  updateBasicProfile,
  createBasicProfile,
  updateDoctorActiveStatus,
  refreshDoctorProfile,
  removeProfilePic,
  uploadSignatureImage,
} from '../../services';
import doctorPlaceholder from '../../images/common/placeholderDoctor.png';
import ISO6391 from 'iso-639-1';
import LanguageSelect from 'react-select';
import makeAnimated from 'react-select/animated';

const { Option } = Select;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  width: 100%;
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 14px;
`;

const StyledNumberInputBox = styled(NumberInput)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  width: 100%;
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 14px;
`;

const GendersContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  align-self: stretch;
  align-items: center;
  margin-bottom: 14px;
`;

const GenderContainer = styled(Tappable)`
  margin-right: 1.5rem;
  display: flex;
  flex-shrink: 0;
  align-items: center;

  &.Tappable-active {
    opacity: 0.5;
  }
`;

const GenderIcon = styled.div`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 8px;
  background: ${(props) => (props.active ? '#7651da' : '#e7e7e7')};
  margin-right: 0.75rem;
`;

const GenderText = styled(SemiboldText)`
  font-size: 16px;
  color: #514f54;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const CheckboxComponent = styled(Checkbox)`
  font-size: 16px;
  color: #514f54;
  /* margin-top: 0.625rem; */
  margin-bottom: 1.25rem;
  margin-left: 0 !important;
`;

const ProfileImageTappable = styled(Tappable)`
  display: block;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const ProfileImage = styled.img`
  max-width: 100px;
  max-height: 100px;
  border-radius: 50px;
`;

const SignatureImage = styled.img`
  max-width: 100px;
  max-height: 100px;
`;

const StyledUploadingComponent = styled(UploadingComponent)`
  margin: 0;
`;

const NightDoctorText = styled(SemiboldText)`
  font-size: 16px;
  color: #514f54;
`;

const animatedComponents = makeAnimated();

class DoctorBasicProfileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      doctorName: '',
      doctorEmail: '',
      doctorAddress: '',
      doctorPhone: '',
      doctorGender: '',
      doctorDescription: '',
      doctorQualifications: '',
      doctorPassword: '',
      practiceYears: '',
      isOnlineDoctor: false,
      isOfflineDoctor: false,
      doctorVerticalId: '',
      doctorSpeciality: '',
      referenceId: '',
      profileImage: '',
      isDoctorActive: false,
      doctorSignature: '',
      knownLanguages: '',
      isNightDoctor: false,
      isMorningDoctor: false,
      networkSource: '',
      videoPreference: false,
      isHomeAppointmentAvailable: false,
      homeAppointmentRange: '',
      onlineSlotDuration: '15',
      onlyAvailableForBookForLater: false,
      scheduleConsultCancelWindowEnds: '2',
      onlineSlotCalcWindow: '2',
      latitude: '',
      longitude: '',
      homeAppointmentCharges: '',
      accessForQcDashboard: false,
      city: null,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    if (this.doctorId && this.doctorId !== -1) {
      this.fetchProfile();
    }
  };

  fetchProfile = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    fetchBasicProfile(this.doctorId)
      .then((res) => {
        const basicProfile = res.data;
        dispatch(setDoctorProfile({ basicProfile }));
        const langOptions = basicProfile.knownLanguages
          .split(',')
          .map((lang) => {
            return { label: lang, value: lang };
          });
        if (langOptions.length === 1 && langOptions[0].value === '') {
          langOptions.pop();
        }
        this.setState({
          doctorName: basicProfile.doctorName || '',
          doctorEmail: basicProfile.doctorEmail || '',
          doctorAddress: basicProfile.doctorAddress || '',
          doctorPhone: basicProfile.doctorPhone || '',
          doctorGender: basicProfile.doctorGender || '',
          doctorDescription: basicProfile.doctorDescription || '',
          doctorQualifications: basicProfile.doctorQualifications || '',
          practiceYears: basicProfile.practiceYears || '',
          isOnlineDoctor: basicProfile.isOnlineDoctor || false,
          isOfflineDoctor: basicProfile.isOfflineDoctor || false,
          isHomeAppointmentAvailable:
            basicProfile.isHomeAppointmentAvailable || false,
          doctorVerticalId: basicProfile.doctorVerticalId || '',
          doctorSpeciality: basicProfile.doctorSpeciality || '',
          referenceId: basicProfile.referenceId || '',
          profileImage: basicProfile.profileImage || '',
          isDoctorActive: basicProfile.isDoctorActive || false,
          doctorSignature: basicProfile.signatureImage,
          knownLanguages: langOptions || '',
          isNightDoctor: basicProfile.isNightDoctor || false,
          networkSource: basicProfile.networkSource,
          videoPreference: basicProfile.preference === 'video' ? true : false,
          onlineSlotDuration: basicProfile.onlineSlotDuration || '15',
          onlyAvailableForBookForLater:
            basicProfile.onlyAvailableForBookForLater || false,
          scheduleConsultCancelWindowEnds:
            basicProfile.scheduleConsultCancelWindowEnds || '2',
          homeAppointmentRange: basicProfile.homeAppointmentRange || '',
          onlineSlotCalcWindow: basicProfile.onlineSlotCalcWindow || '2',
          latitude: basicProfile.latitude || '',
          longitude: basicProfile.longitude || '',
          homeAppointmentCharges: basicProfile.homeAppointmentCharges || '',
          accessForQcDashboard: basicProfile.accessForQcDashboard || false,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  checkboxChangeEvent = (e, type) => {
    console.log(`checked = ${e.target.checked}, type = ${type}`);
    switch (type) {
      case 'online':
        this.setState({
          isOnlineDoctor: e.target.checked,
        });
        break;
      case 'offline':
        this.setState({
          isOfflineDoctor: e.target.checked,
        });
        break;
      case 'night':
        this.setState({
          isNightDoctor: e.target.checked,
          // isMorningDoctor: !e.target.checked,
        });
        break;
      case 'morning':
        this.setState({
          // isMorningDoctor: e.target.checked,
          isNightDoctor: !e.target.checked,
        });
        break;
      case 'video':
        this.setState({
          videoPreference: e.target.checked,
        });
        break;
      case 'home':
        this.setState({
          isHomeAppointmentAvailable: e.target.checked,
        });
        break;
      case 'notOnlyBookForLater':
        this.setState({
          onlyAvailableForBookForLater: e.target.checked,
        });
        break;
      case 'onlyBookForLater':
        this.setState({
          onlyAvailableForBookForLater: !e.target.checked,
        });
        break;
      case 'accessForQcDashboard':
        this.setState({
          accessForQcDashboard: e.target.checked,
        });
        break;
      default:
        break;
    }
  };

  onOptionSelect = (option) => {
    console.log({ option });
    this.setState({
      doctorVerticalId: option,
    });
  };

  customStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: 16,
      color: '#514f54',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    valueContainer: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    input: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
  };

  handleAttachment = () => {
    const { authToken } = this.props;
    const file = document.querySelector('#imageAttachment').files[0];
    if (file) {
      this.setState({
        uploading: true,
      });
      document.querySelector('#imageAttachment').value = null;
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          this.setState({
            uploadProgress: (loaded / total) * 100,
          });
        } else {
          this.setState({
            uploadProgress: 100,
          });
        }
      };
      uploadProfilePicture(file, this.doctorId, onUploadProgress, authToken)
        .then(() => {
          this.setState({
            uploading: false,
            uploadProgress: 0,
          });
          this.fetchProfile();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleSignatureAttachment = () => {
    const { authToken } = this.props;
    const file = document.querySelector('#signatureImage').files[0];
    if (file) {
      this.setState({
        uploading: true,
      });
      document.querySelector('#signatureImage').value = null;
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          this.setState({
            uploadProgress: (loaded / total) * 100,
          });
        } else {
          this.setState({
            uploadProgress: 100,
          });
        }
      };
      uploadSignatureImage(file, this.doctorId, onUploadProgress, authToken)
        .then(() => {
          this.setState({
            uploading: false,
            uploadProgress: 0,
          });
          this.fetchProfile();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  mapNetworkSourceToId = (source) => {
    switch (source) {
      case 'practo':
        return 1;
      case 'credihealth':
        return 2;
      case 'medibuddy':
        return 3;
      case 'Visit Online':
        return 4;
      case 'Doc Prime':
        return 5;
      case 'Visit Onboarded':
        return 6;
      case 'Ayu Health':
        return 7;
      case 'Tatva':
        return 8;
      default:
        return 6;
    }
  };

  submit = () => {
    const { history } = this.props;
    const {
      doctorName,
      doctorEmail,
      doctorAddress,
      doctorPhone,
      doctorGender,
      doctorDescription,
      doctorPassword,
      doctorQualifications,
      practiceYears,
      isOnlineDoctor,
      isOfflineDoctor,
      doctorVerticalId,
      doctorSpeciality,
      referenceId,
      knownLanguages,
      isNightDoctor,
      networkSource,
      videoPreference,
      isHomeAppointmentAvailable,
      onlyAvailableForBookForLater,
      onlineSlotDuration,
      scheduleConsultCancelWindowEnds,
      homeAppointmentRange,
      onlineSlotCalcWindow,
      latitude,
      longitude,
      homeAppointmentCharges,
      accessForQcDashboard,
      city,
    } = this.state;
    let preference = 'voice';
    let updateNetworkSource = networkSource;
    if (videoPreference) {
      preference = 'video';
    }
    this.setState({ loading: true });

    if (this.doctorId && this.doctorId !== -1) {
      if (isNaN(networkSource)) {
        // map it to number
        updateNetworkSource = this.mapNetworkSourceToId(networkSource);
      }
      updateBasicProfile({
        doctorId: this.doctorId,
        doctorName,
        doctorEmail,
        doctorAddress,
        doctorPhone,
        doctorGender,
        doctorDescription,
        doctorPassword,
        doctorQualifications,
        practiceYears,
        isOnlineDoctor,
        isOfflineDoctor,
        doctorVerticalId,
        doctorSpeciality,
        referenceId,
        knownLanguages: knownLanguages.map((lang) => lang.value).join(','),
        isNightDoctor,
        networkSource: updateNetworkSource,
        preference,
        onlyAvailableForBookForLater,
        onlineSlotDuration,
        scheduleConsultCancelWindowEnds,
        onlineSlotCalcWindow,
        isHomeAppointmentAvailable:
          doctorVerticalId === 26 ? isHomeAppointmentAvailable : null,
        homeAppointmentRange: isHomeAppointmentAvailable
          ? homeAppointmentRange
          : null,
        latitude: isHomeAppointmentAvailable
          ? latitude
          : city
          ? city.lat
          : null,
        longitude: isHomeAppointmentAvailable
          ? longitude
          : city
          ? city.lng
          : null,
        homeAppointmentCharges: isHomeAppointmentAvailable
          ? homeAppointmentCharges
          : null,
        accessForQcDashboard,
        city: (city && city.value) || null,
      })
        .then(() => {
          this.fetchProfile();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    } else {
      createBasicProfile({
        doctorName,
        doctorEmail,
        doctorAddress,
        doctorPhone,
        doctorPassword: doctorPassword || undefined,
        doctorGender,
        doctorDescription,
        doctorQualifications,
        practiceYears,
        isOnlineDoctor,
        isOfflineDoctor,
        doctorVerticalId,
        doctorSpeciality,
        referenceId,
        knownLanguages:
          knownLanguages && knownLanguages.length > 0
            ? knownLanguages.map((lang) => lang.value).join(',')
            : null,
        isNightDoctor,
        networkSource,
        preference,
        onlyAvailableForBookForLater,
        onlineSlotDuration,
        scheduleConsultCancelWindowEnds,
        onlineSlotCalcWindow,
        isHomeAppointmentAvailable:
          doctorVerticalId === 26 ? isHomeAppointmentAvailable : null,
        homeAppointmentRange: isHomeAppointmentAvailable
          ? homeAppointmentRange
          : null,
        latitude: isHomeAppointmentAvailable
          ? latitude
          : city
          ? city.lat
          : null,
        longitude: isHomeAppointmentAvailable
          ? longitude
          : city
          ? city.lng
          : null,
        homeAppointmentCharges: isHomeAppointmentAvailable
          ? homeAppointmentCharges
          : null,
        accessForQcDashboard,
        city: (city && city.value) || null,
      })
        .then((res) => {
          this.doctorId = res.doctorId;
          // Redirect to the doctor profile page
          history.push(`/doctor-profile/${this.doctorId}`);
          // this.fetchProfile();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  onChangeStatus = (checked) => {
    console.log(`switch to ${checked}`);
    updateDoctorActiveStatus(this.doctorId, checked)
      .then(() => {
        this.fetchProfile();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  removeProfilePic = () => {
    removeProfilePic(this.doctorId)
      .then(() => {
        this.fetchProfile();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  handleNetworkSourceChange = (value) => {
    console.log('Network Source:', value);
    this.setState({
      networkSource: value,
    });
  };

  handleOnlineSlotDurationChange = (value) => {
    console.log('Online Slot Duration:', value);
    this.setState({
      onlineSlotDuration: value,
    });
  };

  handleScheduleConsultCancelWindowEndsChange = (value) => {
    console.log('Schedule Consult Cancel Window:', value);
    this.setState({
      scheduleConsultCancelWindowEnds: value,
    });
  };

  handleHomeAppointmentRangeChange = (value) => {
    console.log('Home Appointment Range:', value);
    this.setState({
      homeAppointmentRange: value,
    });
  };

  handleOnlineSlotCalcWindowChange = (value) => {
    console.log('Online Slot Calc Window:', value);
    this.setState({
      onlineSlotCalcWindow: value,
    });
  };

  // handlePreferenceChange = (value) => {
  //   console.log('Preference: ', value);
  //   this.setState({
  //     preference: value,
  //   });
  // }

  confirmRefreshProfile = () => {
    const { doctorName } = this.state;
    Modal.confirm({
      title: 'Confirm Refresh',
      content: `Are you sure you want to refresh profile of ${doctorName}`,
      onCancel: () => true,
      onOk: () => {
        this.setState({ loading: true });
        refreshDoctorProfile(this.doctorId)
          .then((res) => {
            message.success(
              `Profile refreshed succcessfully on ${res.refreshedOn}`,
              3
            );
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleLangSelect = (value) => {
    this.setState({ knownLanguages: value }, () => {
      console.log(this.state.knownLanguages, 'knownLanguages');
    });
  };

  handleCityChange = (value) => {
    this.setState({ city: value }, () => {
      console.log(this.state.city, 'city');
    });
  };

  render() {
    const {
      doctorGender,
      isOnlineDoctor,
      isOfflineDoctor,
      doctorVerticalId,
      loading,
      profileImage,
      uploading,
      doctorSignature,
      isNightDoctor,
      videoPreference,
      isHomeAppointmentAvailable,
      onlyAvailableForBookForLater,
      accessForQcDashboard,
    } = this.state;
    let { verticals, cities } = this.props;
    const doctorNameLink = Link.state(this, 'doctorName');
    const doctorPhoneLink = Link.state(this, 'doctorPhone');
    const doctorEmailLink = Link.state(this, 'doctorEmail');
    const doctorAddressLink = Link.state(this, 'doctorAddress');
    const doctorDescriptionLink = Link.state(this, 'doctorDescription');
    const doctorQualificationsLink = Link.state(this, 'doctorQualifications');
    const practiceYearsLink = Link.state(this, 'practiceYears');
    const doctorSpecialityLink = Link.state(this, 'doctorSpeciality');
    const referenceIdInputLink = Link.state(this, 'referenceId');
    const doctorPasswordLink = Link.state(this, 'doctorPassword');
    const knownLanguagesLink = Link.state(this, 'knownLanguages');
    const latitudeLink = Link.state(this, 'latitude');
    const longitudeLink = Link.state(this, 'longitude');
    const homeAppointmentChargesLink = Link.state(
      this,
      'homeAppointmentCharges'
    );
    const homeAppointmentRangeLink = Link.state(this, 'homeAppointmentRange');

    const langOptions = ISO6391.getAllNames()
      .concat([
        'Punjabi',
        'Odia',
        'Konkani',
        'Marwadi',
        'Kokborok',
        'Lepcha',
        'Manipuri',
        'Sikkimese',
        'Konyak',
        'Khasi',
        'Nissi',
        'Dafla',
        'Mizo',
        'Aimol',
      ])
      .map((lang) => {
        return { label: lang, value: lang };
      });

    console.log(langOptions, 'langOptions');
    cities = cities.map((ele) => {
      return {
        label: ele.label,
        value: ele.value,
        lat: ele.latitude,
        lng: ele.longitude,
      };
    });
    console.log(cities, 'cities');

    return (
      <Row type="flex" gutter={16}>
        {this.state.uploading && (
          <Col span={24}>
            <StyledUploadingComponent
              uploadProgress={`${this.state.uploadProgress}%`}
              borderRadius={0}
            />
          </Col>
        )}
        <Col span={18}>
          <TitleText>{`Doctor Basic Profile Screen (Doctor ID: ${this.props.doctorId})`}</TitleText>
        </Col>
        <Col span={6}>
          <Button type="danger" onClick={this.confirmRefreshProfile}>
            Refresh Profile
          </Button>
        </Col>
        {loading ? (
          <Spin spinning={loading} />
        ) : (
          <>
            <Col xs={{ order: 2, span: 24 }} md={{ order: 1, span: 12 }}>
              <Row>
                <Col span={24}>
                  <LabelText>Doctor Name</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={doctorNameLink}
                    placeholder="Name"
                  />
                </Col>
                <Col span={24}>
                  <LabelText>Network Source</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={this.state.networkSource}
                    onChange={this.handleNetworkSourceChange}
                  >
                    <Option value="1">Practo</Option>
                    <Option value="2">CrediHealth</Option>
                    <Option value="3">Medibuddy</Option>
                    <Option value="4">Visit Online</Option>
                    <Option value="5">DocPrime</Option>
                    <Option value="6">Visit Onboarded</Option>
                    <Option value="7">Ayu Health</Option>
                    <Option value="8">Tatva</Option>
                  </Select>
                </Col>
                {/*/!*Communication preference*!/*/}
                {/*<Col span={24}>*/}
                {/*  <LabelText>Preference</LabelText>*/}
                {/*  <Select*/}
                {/*      style={{width: '100%'}}*/}
                {/*      value={this.state.preference}*/}
                {/*      onChange={this.handlePreferenceChange}*/}
                {/*  >*/}
                {/*    <Option value="voice">Voice</Option>*/}
                {/*    <Option value="video">Video</Option>*/}
                {/*  </Select>*/}
                {/*</Col>*/}
                {/* {this.state.validationErrors.dependentName ? (
              <ValidationText>
                {this.state.validationErrors.dependentName.errorMessage}
              </ValidationText>
            ) : null} */}
                <Col span={24}>
                  <LabelText>Doctor Email</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={doctorEmailLink}
                    placeholder="Email"
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Doctor Address</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={doctorAddressLink}
                    placeholder="Address"
                  />
                </Col>
                <Col span={24}>
                  <LabelText>Doctor City For Tele Consultation</LabelText>
                  <LanguageSelect
                    closeMenuOnSelect={false}
                    options={cities}
                    value={this.state.city}
                    onChange={this.handleCityChange}
                    components={animatedComponents}
                  />
                </Col>
                <Col span={24}>
                  <LabelText>Doctor Phone</LabelText>
                  <StyledInputBox
                    type="tel"
                    className="visit-input"
                    valueLink={doctorPhoneLink}
                    placeholder="Phone"
                    maxLength={10}
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Doctor Password</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={doctorPasswordLink}
                    placeholder="Password (Optional)"
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Doctor Gender</LabelText>
                  <GendersContainer>
                    <GenderContainer
                      onTap={() => this.setState({ doctorGender: 'Male' })}
                    >
                      <GenderIcon active={doctorGender === 'Male'} />
                      <GenderText>Male</GenderText>
                    </GenderContainer>
                    <GenderContainer
                      onTap={() => this.setState({ doctorGender: 'Female' })}
                    >
                      <GenderIcon active={doctorGender === 'Female'} />
                      <GenderText>Female</GenderText>
                    </GenderContainer>
                  </GendersContainer>
                </Col>

                <Col span={24}>
                  <LabelText>Doctor Description</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={doctorDescriptionLink}
                    placeholder="Description"
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Doctor Qualifications</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={doctorQualificationsLink}
                    placeholder="Qualifications"
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Practice Years</LabelText>
                  <StyledNumberInputBox
                    type="tel"
                    className="visit-input"
                    valueLink={practiceYearsLink}
                    placeholder="Practice Years"
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Doctor Speciality</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={doctorSpecialityLink}
                    placeholder="Doctor Speciality"
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Reference ID</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={referenceIdInputLink}
                    placeholder="Reference ID"
                  />
                </Col>
                <Col span={24}>
                  <LabelText>Languages</LabelText>
                  <LanguageSelect
                    isMulti
                    closeMenuOnSelect={false}
                    options={langOptions}
                    value={this.state.knownLanguages}
                    onChange={this.handleLangSelect}
                    components={animatedComponents}
                  />
                  {/* <StyledInputBox
                    className="visit-input"
                    valueLink={knownLanguagesLink}
                    placeholder="Known Languages"
                  /> */}
                </Col>

                <Col span={24}>
                  <LabelText>
                    Only available for Book For Later in Online Consults
                  </LabelText>
                  <CheckboxComponent
                    checked={onlyAvailableForBookForLater}
                    onChange={(e) =>
                      this.checkboxChangeEvent(e, 'notOnlyBookForLater')
                    }
                  >
                    Yes
                  </CheckboxComponent>
                  <CheckboxComponent
                    checked={!onlyAvailableForBookForLater}
                    onChange={(e) =>
                      this.checkboxChangeEvent(e, 'onlyBookForLater')
                    }
                  >
                    No
                  </CheckboxComponent>
                </Col>
                <Col span={24}>
                  <LabelText>Online Slot Duration</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={this.state.onlineSlotDuration}
                    onChange={this.handleOnlineSlotDurationChange}
                  >
                    <Option value="15">15</Option>
                    <Option value="30">30</Option>
                  </Select>
                </Col>
                <Col span={24}>
                  <LabelText>
                    Schedule Consult Cancel Window Open till(hours):
                  </LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={this.state.scheduleConsultCancelWindowEnds}
                    onChange={this.handleScheduleConsultCancelWindowEndsChange}
                  >
                    <Option value="2">2</Option>
                    <Option value="4">4</Option>
                    <Option value="8">8</Option>
                    <Option value="16">16</Option>
                    <Option value="24">24</Option>
                  </Select>
                </Col>
                <Col span={24}>
                  <LabelText>Online Slot Calculation Window(weeks):</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={this.state.onlineSlotCalcWindow}
                    onChange={this.handleOnlineSlotCalcWindowChange}
                  >
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                  </Select>
                </Col>
                <Col span={24}>
                  <LabelText>Night Doctor</LabelText>
                  <CheckboxComponent
                    checked={isNightDoctor}
                    onChange={(e) => this.checkboxChangeEvent(e, 'night')}
                  >
                    Yes
                  </CheckboxComponent>
                  <CheckboxComponent
                    checked={!isNightDoctor}
                    onChange={(e) => this.checkboxChangeEvent(e, 'morning')}
                  >
                    No
                  </CheckboxComponent>
                </Col>

                <Col span={24}>
                  <LabelText>Doctor Vertical</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Doctor Vertical"
                    value={doctorVerticalId}
                    onChange={(option) => this.onOptionSelect(option)}
                  >
                    {verticals.map((ele) => (
                      <Option key={ele.id} value={ele.id}>
                        {ele.name}
                      </Option>
                    ))}
                  </Select>
                </Col>

                <CheckboxComponent
                  checked={isOnlineDoctor}
                  onChange={(e) => this.checkboxChangeEvent(e, 'online')}
                >
                  Available for Online Consultations
                </CheckboxComponent>
                <CheckboxComponent
                  checked={isOfflineDoctor}
                  onChange={(e) => this.checkboxChangeEvent(e, 'offline')}
                >
                  Available for Offline Consultations
                </CheckboxComponent>
                <CheckboxComponent
                  checked={videoPreference}
                  onChange={(e) => this.checkboxChangeEvent(e, 'video')}
                >
                  Can take video calls
                </CheckboxComponent>
                <CheckboxComponent
                  checked={accessForQcDashboard}
                  onChange={(e) =>
                    this.checkboxChangeEvent(e, 'accessForQcDashboard')
                  }
                >
                  Acces for QC Dashboard
                </CheckboxComponent>
                {doctorVerticalId === 26 ? (
                  <CheckboxComponent
                    checked={isHomeAppointmentAvailable}
                    onChange={(e) => this.checkboxChangeEvent(e, 'home')}
                  >
                    Is home appointment available
                  </CheckboxComponent>
                ) : (
                  <></>
                )}
                {doctorVerticalId === 26 && isHomeAppointmentAvailable ? (
                  <>
                    {/* <Col span={24}>
                      <LabelText>Home Appointment Range:</LabelText>
                      <Select
                        style={{ width: '100%' }}
                        value={this.state.homeAppointmentRange}
                        onChange={this.handleHomeAppointmentRangeChange}
                      >
                        <Option value="With in 5 km">5</Option>
                        <Option value="With in 10 km">10</Option>
                        <Option value="With in 15 km">With in 15 km</Option>
                      </Select>
                    </Col>
                    
                    */}

                    <Col span={24}>
                      <LabelText>Home Appointment Range(km):</LabelText>
                      <StyledInputBox
                        type="tel"
                        className="visit-input"
                        valueLink={homeAppointmentRangeLink}
                        placeholder="home appointment range"
                        maxLength={3}
                        maxValue={200}
                      />
                    </Col>

                    <Col span={24}>
                      <LabelText>Latitude</LabelText>
                      <StyledInputBox
                        className="visit-input"
                        valueLink={latitudeLink}
                        placeholder="latitude"
                      />
                    </Col>
                    <Col span={24}>
                      <LabelText>Longitude</LabelText>
                      <StyledInputBox
                        className="visit-input"
                        valueLink={longitudeLink}
                        placeholder="longitude"
                      />
                    </Col>
                    <Col span={24}>
                      <LabelText>Home appointment charges</LabelText>
                      <StyledInputBox
                        className="visit-input"
                        valueLink={homeAppointmentChargesLink}
                        placeholder="Home appointment charges"
                      />
                    </Col>
                  </>
                ) : (
                  <></>
                )}
                <Col span={24}>
                  <Button
                    block
                    type="primary"
                    size="large"
                    onClick={this.submit}
                  >
                    <ButtonText>Submit</ButtonText>
                  </Button>
                </Col>
              </Row>
            </Col>

            <Col xs={{ order: 1, span: 24 }} md={{ order: 2, span: 12 }}>
              <Row type="flex" justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <TitleText>Upload Profile Photo</TitleText>
                  <input
                    type="file"
                    id="imageAttachment"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={this.handleAttachment}
                  />
                  <input
                    type="file"
                    id="signatureImage"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={this.handleSignatureAttachment}
                  />
                  {this.doctorId !== -1 && !uploading ? (
                    <>
                      <ProfileImageTappable
                        disabled
                        onTap={() =>
                          document.querySelector('#imageAttachment').click()
                        }
                      >
                        <ProfileImage src={profileImage || doctorPlaceholder} />
                      </ProfileImageTappable>
                      {profileImage && (
                        <Button onClick={this.removeProfilePic} icon="stop">
                          Remove Profile Pic
                        </Button>
                      )}
                      <ProfileImageTappable
                        disabled
                        onTap={() =>
                          document.querySelector('#signatureImage').click()
                        }
                      >
                        {doctorSignature ? (
                          <SignatureImage src={doctorSignature} />
                        ) : (
                          <Button icon="upload">Upload Signature</Button>
                        )}
                      </ProfileImageTappable>
                    </>
                  ) : (
                    <TitleText>First upload basic details</TitleText>
                  )}
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  verticals: state.info.verticals,
  cities: state.info.cities,
});

export default withRouter(connect(mapStateToProps)(DoctorBasicProfileScreen));
